import React from 'react';
import SEO from './SEO';
import Header from './Header';
import Footer from './Footer';
import { useReveal } from '../hooks/useReveal';

interface LegalPageProps {
  title: string;
  updated: string;
  url: string;
  children: React.ReactNode;
}

/** Layout para páginas legales: contenido editorial en dos columnas. */
const LegalPage = ({ title, updated, url, children }: LegalPageProps) => {
  useReveal();
  return (
    <div className="relative min-h-screen bg-paper text-ink grain">
      <SEO title={title} url={url} noindex />
      <Header />
      <main className="pt-[130px] pb-24 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="border-b border-line pb-8 mb-12">
            <p className="label">{updated}</p>
            <h1 className="font-display font-black uppercase tracking-[-0.02em] text-[clamp(2rem,5vw,3.2rem)] mt-4">
              {title}
            </h1>
          </div>
          <div className="space-y-10">{children}</div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export const LegalSection = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <section className="reveal">
    <h2 className="font-display font-bold uppercase tracking-tight text-lg md:text-xl">{title}</h2>
    <div className="mt-4 space-y-4 text-ink-soft leading-relaxed text-[0.95rem]">{children}</div>
  </section>
);

export default LegalPage;
